import React, { useState, useEffect } from 'react';
import { heroData } from '../utils/mockData';
import { useSection, resolveAsset } from '../contexts/ContentContext';

const Hero = ({ onExplore }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const data = useSection('home.hero', {
    eyebrow: 'Silk & Sentiment',
    title: heroData.title,
    subtitle: heroData.subtitle,
    tagline: 'Handcrafted in Lucknow. Curated for the World.\nBy Appointment Only.',
    ctaText: heroData.ctaText,
    image: heroData.heroImage,
  });
  const heroImage = resolveAsset(data.image) || heroData.heroImage;

  useEffect(() => {
    const img = new Image();
    img.src = heroImage;
    img.onload = () => setImageLoaded(true);
  }, [heroImage]);

  return (
    <section className="hero-section" style={styles.hero}>
      <div style={styles.heroImageContainer}>
        <img
          src={heroImage}
          alt="Luxury silk fabric"
          style={{
            ...styles.heroImage,
            opacity: imageLoaded ? 1 : 0,
          }}
          onLoad={() => setImageLoaded(true)}
        />
        <div style={styles.overlay}></div>
      </div>
      <div style={styles.heroContent} className="luxury-container">
        <div style={styles.heroText} className="fade-in">
          <p style={styles.eyebrow}>{data.eyebrow}</p>
          <h1 className="hero-large" style={styles.title}>
            {data.title}
          </h1>
          <p className="hero-medium" style={styles.subtitle}>
            {data.subtitle}
          </p>
          <p className="body-regular" style={styles.tagline}>
            {(data.tagline || '').split('\n').map((line, i, arr) => (
              <React.Fragment key={i}>
                {line}
                {i < arr.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
          <button
            className="btn-primary"
            style={styles.ctaButton}
            onClick={onExplore}
            aria-label="Explore the Archives"
          >
            {data.ctaText}
          </button>
        </div>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    minHeight: '600px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--bg-primary)',
    overflow: 'hidden',
  },
  heroImageContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
  },
  heroImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center right',
    filter: 'saturate(1.08) contrast(1.04)',
    transition: 'opacity 1s ease-in-out, transform 20s ease-in-out',
    animation: 'subtleZoom 20s ease-in-out infinite alternate',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(90deg, rgba(255,254,242,0.92) 0%, rgba(255,254,242,0.78) 28%, rgba(255,254,242,0.35) 48%, rgba(255,254,242,0.05) 62%, rgba(255,254,242,0) 75%)',
    zIndex: 2,
    pointerEvents: 'none',
  },
  heroContent: {
    position: 'relative',
    zIndex: 3,
    textAlign: 'left',
    padding: '0 48px',
    width: '100%',
  },
  heroText: {
    maxWidth: '560px',
    marginLeft: '0',
    marginRight: 'auto',
  },
  eyebrow: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '11px',
    letterSpacing: '0.35em',
    textTransform: 'uppercase',
    color: 'var(--accent-gold)',
    marginBottom: '20px',
  },
  title: {
    marginBottom: '16px',
    textAlign: 'left',
  },
  subtitle: {
    marginBottom: '24px',
    textAlign: 'left',
  },
  tagline: {
    marginBottom: '40px',
    color: 'var(--text-secondary)',
    letterSpacing: '0.04em',
    lineHeight: '1.8',
    textAlign: 'left',
  },
  ctaButton: {
    marginTop: '8px',
  },
};

// Keyframe animation for subtle zoom
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes subtleZoom {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.05);
    }
  }
`;
document.head.appendChild(styleSheet);

const responsive = document.createElement('style');
responsive.textContent = `
  @media (max-width: 768px) {
    .hero-section > div:last-child {
      padding: 0 24px !important;
    }
    .hero-section > div:last-child > div {
      max-width: 100% !important;
    }
  }
`;
document.head.appendChild(responsive);

export default Hero;
